import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { APP_ROUTES } from '../../common/constants'

import { ReportsPage } from './pages'

const ReportsRouter = () => (
  <Switch>
    <Route
      path={APP_ROUTES.OTHER.subMenuItems.REPORTS.link}
      component={ReportsPage}
    />
  </Switch>
)

export default ReportsRouter
